<template>
  <!--
    作者：gmshop
    时间：2020-06-25
    描述：插件中心-分红奖金池-基础设置
  -->
  <div class="user" v-loading="loading">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <div class="common-form">分红奖金池设置</div>

      <el-form-item label="是否开启分红奖金：">
        <el-radio-group v-model="form.is_bonus">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="上月累计团队业绩:">
        <div class="gray9">设置后，会员需要上月累计团队业绩大于或等于设置值才能进行分红</div>
        <div class="max-w460">
          <el-table :data="gradeList" border size="mini" style="width: 100%">
            <el-table-column prop="name" label="会员等级">
            </el-table-column>
            <el-table-column prop="name" label="业绩">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input v-model="scope.row.performance" type="number" placeholder="请输入分红上限"></el-input>
                  <span class="ml10">单</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>

      <el-form-item label="累计分红上限:">
        <div class="max-w460">
          <el-table :data="gradeList" border size="mini" style="width: 100%">
            <el-table-column prop="name" label="会员等级">
            </el-table-column>
            <el-table-column prop="name" label="分红上限">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input v-model="scope.row.upper_limit" type="number" placeholder="请输入分红上限"></el-input>
                  <span class="ml10">元</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>

      <el-form-item label="虚拟人数:">
        <div class="max-w460">
          <el-table :data="gradeList" border size="mini" style="width: 100%">
            <el-table-column prop="name" label="会员等级">
            </el-table-column>
            <el-table-column prop="name" label="虚拟人数">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input v-model="scope.row.number" type="number" placeholder="请输入虚拟人数"></el-input>
                  <span class="ml10">人</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
  </div>
</template>

<script>
import BonusApi from '@/api/plus/bonus.js';
export default {
  components: {
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*表单对象*/
      form: {
        /*是否开启分红奖金*/
        is_bonus: 0,
        /*进行分红等级*/
        bonus_grade:[],
      },
      gradeList: [],
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*获取数据*/
    getData(){
      let self = this;
      self.loading = true;
      BonusApi.getData({}, true)
        .then(res => {
          /*累计分红上限*/
          if(res.data.detail.bonus_upper_limit!=null&&typeof res.data.detail.bonus_upper_limit !='undefined'){
            let equitys=res.data.detail.bonus_upper_limit;
            res.data.gradeList.forEach(item=>{
              console.log(equitys[item.grade_id])
              item.upper_limit=(equitys[item.grade_id] == null || equitys[item.grade_id] == "") ? 0 : equitys[item.grade_id];
            });
          }
          /*虚拟人数*/
          if(res.data.detail.virtual_number!=null&&typeof res.data.detail.virtual_number !='undefined'){
            let equitys=res.data.detail.virtual_number;
            res.data.gradeList.forEach(item=>{
              item.number=(equitys[item.grade_id] == null || equitys[item.grade_id] == "") ? 0 : equitys[item.grade_id];
            });
          }
          /*上月累计团队业绩*/
          if(res.data.detail.team_performance!=null&&typeof res.data.detail.team_performance !='undefined'){
            let equitys=res.data.detail.team_performance;
            res.data.gradeList.forEach(item=>{
              console.log(equitys[item.grade_id])
              item.performance=(equitys[item.grade_id] == null || equitys[item.grade_id] == "") ? 0 : equitys[item.grade_id];
            });
          }
          self.form=res.data.detail;
          self.gradeList = res.data.gradeList;
          // console.log(self.form);
          self.loading = false;
        })
        .catch(error => {});
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = self.form;
      params.bonus_upper_limit=self.convertBonusJson(self.gradeList);
      params.virtual_number=self.convertNumberJson(self.gradeList);
      params.team_performance=self.convertPerformanceJson(self.gradeList);
      BonusApi.saveData(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，保存成功',
            type: 'success'
          });
          this.getData();
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*转JSON字符串*/
    convertBonusJson(list){
      let obj={};
      list.forEach(item=>{
        obj[item.grade_id]=item.upper_limit;
      });
      return JSON.stringify(obj);
    },

    /*转JSON字符串*/
    convertNumberJson(list){
      let obj={};
      list.forEach(item=>{
        obj[item.grade_id]=item.number;
      });
      return JSON.stringify(obj);
    },

    /*转JSON字符串*/
    convertPerformanceJson(list){
      let obj={};
      list.forEach(item=>{
        obj[item.grade_id]=item.performance;
      });
      return JSON.stringify(obj);
    },
  }
};
</script>

<style lang="scss">
.spec-min-box > i {
  position: absolute;
  right: 0;
  font-size: 16px;
  cursor: pointer;
}
.spec-min-box .el-icon-close {
  top: 0;
  color: red;
  visibility: hidden;
}
td:hover .spec-min-box .el-icon-close {
  visibility: visible;
}
.spec-min-box .el-icon-caret-right {
  bottom: 0;
  transform: rotate(45deg);
  color: #3a8ee6;
}
.el-form-item.is-error .active-all-set .el-input__inner,
.el-form-item.is-error .isvalid .el-input__inner
{border-color: #C0C4CC;}
</style>



// WEBPACK FOOTER //
// src/views/plus/bonus/setting/getSetting.vue